<div class="no-print container mt-3 mb-1">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h3>
        <span class="font-bold"
          >{{ activeSeasonId }}
          {{ 'selectVaccines.season' | cxTranslate }}</span
        >
      </h3>
    </div>
    <div class="d-flex gap-3">
      <span class="c-link" (click)="backToDashBoard()">
        <i class="fa fa-icon fa-chevron-left"></i>
        {{ 'selectVaccines.back_to_db' | cxTranslate }}</span
      >
      <span class="c-link" (click)="onFluPrint()">
        <i class="fa fa-icon fa-print"></i>
        {{ 'selectVaccines.print' | cxTranslate }}</span
      >
    </div>
  </div>
</div>

<app-flu-header [selectedHeader]="header"></app-flu-header>

<!---------------------------------------select vaccine------------------------------->

<section class="container select-Container">
  <section class="row">
    <!--left sec-->
    <section class="col-8 mt-5 u-border-top-grey">
      <h3 class="font-bold my-4">
        {{ 'selectVaccines.select_Inf_Msg' | cxTranslate }}
      </h3>
      <div>
        <section
          class="row mx-0 py-4 u-border-top-grey"
          *ngFor="let product of fluProductsList; let i = index"
          id="{{ product.code }}">
          <section class="col-2">
            <a (click)="productDetails(product)">
              <cx-media
                *ngIf="product.images"
                [container]="product.images"
                format="thumbnail">
              </cx-media>
              <img *ngIf="!product.images" [src]="fallbackImage" alt="defImg" />
            </a>
          </section>
          <section class="col-lg-5 c-prod-details">
            <a (click)="productDetails(product)">
              <h2
                class="c-heading c-heading-h4 mb-4"
                [innerHTML]="product.name"></h2>
            </a>
            <p
              class="text-fixed-medium color-grey"
              [innerHTML]="product.description"></p>
            <p class="text-fixed-legal-copy color-grey-dark mb-1">
              <span class="font-bold">
                {{ 'selectVaccines.product_number' | cxTranslate }}</span
              >{{ product.sapEan }}
            </p>
          </section>
          <!-- ============================Price=========================================== -->
          <section class="col-xs-6 col-md-6 col-lg-3 price-list">
            <section class="row" *ngIf="isPharmacyUser$ | async">
              <section class="col-md-12">
                <span class="c-heading c-heading-h3">{{
                  product?.price?.formattedValue
                }}</span>
              </section>
            </section>
          </section>
          <!-- ==============================units========================================== -->
          <section class="col-2 p0">
            <section
              class="prodUnits"
              *ngIf="
                product.available === true && product.discontinued === false;
                else NotAccept
              ">
              <div class="mb-2 text-center font-weight-bold color-grey-dark">
                {{ 'selectVaccines.units' | cxTranslate }}
              </div>
              <section
                class="unit-area d-flex flex-nowrap align-items-center justify-content-center">
                <span class="disabled" id="{{ 'minusIcon' + product?.code }}">
                  <button
                    id="{{ 'unitMinus' + product?.code }}"
                    class="disable-action c-count-change-btn"
                    (click)="
                      performQuantityComputation(
                        2,
                        product?.code,
                        product?.quantityPerUnit
                      )
                    ">
                    <i class="fa fa-minus"></i>
                  </button>
                  <button
                    id="{{ 'unitMinusDisable' + product?.code }}"
                    class="c-count-change-btn disabled">
                    <i class="fa fa-minus"></i>
                  </button>
                </span>
                <input
                  type="number"
                  class="prod-quantity text-center"
                  value="{{
                    product?.totalQuantity ? product?.totalQuantity : '0'
                  }}"
                  onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                  (keyup)="
                    performQuantityComputation(
                      null,
                      product?.code,
                      product?.quantityPerUnit
                    )
                  "
                  id="{{ 'prodQuantity' + product?.code }}"
                  min="0"
                  max="99999" />
                <span id="{{ 'plusIcon' + product?.code }}">
                  <button
                    (click)="
                      performQuantityComputation(
                        1,
                        product?.code,
                        product?.quantityPerUnit
                      )
                    "
                    id="{{ 'unitPlus' + product?.code }}"
                    class="c-count-change-btn">
                    <i class="fa fa-plus"></i>
                  </button>
                  <button
                    id="{{ 'unitPlusDisable' + product?.code }}"
                    class="disable-action c-count-change-btn">
                    <i class="fa fa-plus"></i>
                  </button>
                </span>
              </section>

              <section
                class="mt-2 text-center"
                id="{{ 'noOfDoses' + product?.code }}">
                {{ product?.totalDoses ? product?.totalDoses : '' }}
                {{
                  product?.totalDoses
                    ? ('selectVaccines.doses' | cxTranslate)
                    : ''
                }}
              </section>
            </section>

            <ng-template #NotAccept>
              <section class="units-Non-Accepting">
                <span
                  *ngIf="!product.available && product.discontinued === false"
                  class="Not-Available">
                  {{
                    product?.availabilityText
                      ? product?.availabilityText
                      : ('selectVaccines.product_unavailable' | cxTranslate)
                  }}
                </span>
                <span
                  class=""
                  *ngIf="product.discontinued === true"
                  class="Not-Available">
                  {{
                    'selectVaccines.product_discontinued' | cxTranslate
                  }}</span
                >
              </section>
            </ng-template>
          </section>
        </section>
      </div>
    </section>
    <!--right sec-->
    <section class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 no-print mt-5">
      <div class="px-3 pt-2">
        <button
          class="c-button c-button--primary w-100"
          (click)="moveProductsToCart()"
          [ngClass]="{ 'block-Click': apiCallUnderProcess }"
          [disabled]="
            !duplicateProdCheckArray.length ||
            disableButton ||
            (!(isDirectUser$ | async) && !(wholeSalerPharmacy$ | async))
          ">
          <i class="fa fa-spinner fa-spin" *ngIf="apiCallUnderProcess"></i>
          {{ 'selectVaccines.proceed_toCart' | cxTranslate }}
        </button>
        <p class="color-error mt-4" *ngIf="!minDosesThresholdRespected">
          {{
            'checkout.minDosesThreshold.warning'
              | cxTranslate: { '0': minDosesThreshold }
          }}
        </p>
      </div>
      <div
        class="mt-4 u-border-top-grey col-12"
        *ngIf="!(isDirectUser$ | async)">
        <app-wholesaler-pharmacy></app-wholesaler-pharmacy>
      </div>
    </section>
  </section>
</section>
